import { render, staticRenderFns } from "./VolunteerList.vue?vue&type=template&id=0b32d803&scoped=true&lang=pug&"
import script from "./VolunteerList.vue?vue&type=script&lang=js&"
export * from "./VolunteerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32d803",
  null
  
)

export default component.exports